import { render, staticRenderFns } from "./AtomAlertPrimary.vue?vue&type=template&id=c53d6c4c&"
import script from "./AtomAlertPrimary.vue?vue&type=script&lang=js&"
export * from "./AtomAlertPrimary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports